export const env = {
    BASE_URL_ACCOUNT: "https://api.tsp.com.vn/account/",
    API_ROOT: "https://api.tsp.com.vn",
    CDN_URL: "https://cdn.tsp.com.vn",
    OPS_PORTAL_URL: "https://ops.tsp.com.vn/"
}